import { render, staticRenderFns } from "./f01.vue?vue&type=template&id=bba711f0&"
import script from "./f01.vue?vue&type=script&lang=js&"
export * from "./f01.vue?vue&type=script&lang=js&"
import style0 from "./f01.vue?vue&type=style&index=0&id=bba711f0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports